/** Cookie set only when exactly one app is chosen on signup; cleared otherwise. */
export const CHOOSEN_APP_COOKIE_NAME = 'choosen_app';

const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 1;

/** Signup labels (EActivePlatformsNames) → AddApp `selectedApp` / platform keys */
const CHOOSEN_APP_LABEL_TO_PLATFORM: Record<string, string> = {
  GitHub: 'github',
  GitLab: 'gitlab',
  Trello: 'trello',
  Jira: 'jira',
  Notion: 'notion',
  Shopify: 'shopify',
  ChatGPT: 'chatgpt',
  Claude: 'claude',
};

function readRawChoosenAppCookie(): string | null {
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const s = part.trim();
    if (!s.startsWith(`${CHOOSEN_APP_COOKIE_NAME}=`)) continue;
    const raw = s.slice(CHOOSEN_APP_COOKIE_NAME.length + 1);
    try {
      const decoded = decodeURIComponent(raw);
      return decoded || null;
    } catch {
      return raw || null;
    }
  }
  return null;
}

/** Platform key for AddApp (`github`, `jira`, …) or null if cookie missing / unknown label. */
export function getChoosenAppPlatformKey(): string | null {
  const value = readRawChoosenAppCookie();
  if (!value) return null;
  const key = CHOOSEN_APP_LABEL_TO_PLATFORM[value];
  return key ?? null;
}

export function clearChoosenAppCookie(): void {
  document.cookie = `${CHOOSEN_APP_COOKIE_NAME}=;path=/;max-age=0;SameSite=Lax`;
}

/**
 * If exactly one platform is selected, stores its display name (e.g. "GitHub").
 * If zero or multiple, removes the cookie so no stale value remains.
 */
export function syncChoosenAppCookie(selectedApps: string[]): void {
  if (selectedApps.length === 1) {
    document.cookie = `${CHOOSEN_APP_COOKIE_NAME}=${encodeURIComponent(
      selectedApps[0],
    )};path=/;max-age=${COOKIE_MAX_AGE_SEC};SameSite=Lax`;
    return;
  }
  document.cookie = `${CHOOSEN_APP_COOKIE_NAME}=;path=/;max-age=0;SameSite=Lax`;
}
